import React, { useCallback } from 'react'

import { getRoutingPreviousLocation } from '@disco/state-management/selectors/routing'

import { useNavigate, useParams } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'

import { useSelector } from 'hooks/use-redux'
import RightsDataModal from 'components/modals/track/rights-modal'

const ThirdPartyRightsData = ():
  | React.ReactNode
  | React.ReactElement<'div'> => {
  const params = useParams<{ trackId: string }>()
  const navigate = useNavigate()
  const previousLocation = useSelector(getRoutingPreviousLocation)
  const returnTo = previousLocation

  const handleClose = useCallback(() => {
    navigate(returnTo)
  }, [navigate, returnTo])

  return (
    <>
      <DocumentHeadTags title={`Rights Data | DISCO`} />
      <RightsDataModal
        handleClose={handleClose}
        trackId={parseInt(params.trackId)}
      />
    </>
  )
}

export default ThirdPartyRightsData
